import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const KontainerUkuran = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [ukuranKontainer, setUkuranKontainer] = useState('')

    useEffect(() => {
        const getUkuran = async () => {
            const response = await masterService.getUkuranContainerById(id)
            setUkuranKontainer(response.data.ukuranCnt)
        }
        getUkuran()
    }, [masterService, id])

    return (
        <>
            {ukuranKontainer}
        </>
    )
}

export default KontainerUkuran